import { InjectionToken } from '@angular/core';

export const APP_STORAGE = new InjectionToken<string>('Default App Storage');
